import React, {Component} from 'react';
import { Link } from 'react-router-dom';

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";


// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";

import blogGridPic1 from "../../images/blog/grid/enfq/pic1.jpg";
import blogGridPic2 from "../../images/blog/grid/enfq/pic2.jpg";
import blogGridPic3 from "../../images/blog/grid/enfq/pic3.jpg";
import blogGridPic4 from "../../images/blog/grid/enfq/pic4.jpg";
import blogGridPic5 from "../../images/blog/grid/enfq/pic5.jpg";
import blogGridPic6 from "../../images/blog/grid/enfq/pic6.jpg";

// Blog Content
const content = [
	{ 
		name: "Gastritis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=5lc2UP8waIc",		
		definition: "https://medlineplus.gov/spanish/ency/article/001150.htm",
		image:blogGridPic1
	},
	{ 
		name: "Síndrome de Intestino Irritable",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=YBAIPdKPNyA",		
		definition: "https://medlineplus.gov/spanish/irritablebowelsyndrome.html",
		image:blogGridPic2
	},
	{ 
		name: "Colitis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=w0eitJKI5ak",		
		definition: "https://medlineplus.gov/spanish/ency/article/001125.htm",
		image:blogGridPic3
	},
	{ 
		name: "Diverticulitis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=BYfxmnBfjLE",		
		definition: "https://medlineplus.gov/spanish/diverticulosisanddiverticulitis.html",
		image:blogGridPic4
	},
	{ 
		name: "Gastroenteritis",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=Ulezc-1tTyI",		
		definition: "https://medlineplus.gov/spanish/gastroenteritis.html",
		image:blogGridPic5
	},
	{ 
		name: "Ulceras Gástricas",
		subName: "",
		youtube: "https://www.youtube.com/watch?v=--cu0abockM",		
		definition: "https://medlineplus.gov/spanish/pepticulcer.html",
		image:blogGridPic6
	},
	
]

class BlogGrid extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Enfermedades Digestivas Medicas</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Enfermedades Digestivas Medicas</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								{content.map((item) =>(
									<div className="col-xl-4 col-md-6">
										<div className="blog-card mb-30">
											<div className="post-media">
												<img src={item.image} alt=""/>
											</div>
											<div className="post-info">
											<h5 className="post-title" onClick={()=> window.open(item.definition, "_blank")}>{item.name}{item.subName}</h5>	
												<ul className="post-meta">
													<li className="author" onClick={()=> window.open(item.youtube, "_blank")}><i className="la la-youtube"></i>Video Informativo</li>
													<li className="date"  onClick={()=> window.open(item.definition, "_blank")}><i className="fa fa-info-circle"></i>Mas Información</li>
												</ul>
													
											</div>
										</div>							
									</div>
								))}
							</div>
 
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default BlogGrid;